exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.reset-password-link[data-v-e589e72e] {\n  color: #822023;\n  font-size: 11pt;\n  margin-left: 5px;\n}\n.initial-login-link[data-v-e589e72e] {\n  color: #6387AA;\n  margin: 10px;\n  font-weight: 600;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e589e72e","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/header/login/Login.vue
// module id = 695
// module chunks = 1